import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { customDecode, decrypt, noWhitespaceValidator } from '@piqet-angular/data';
import {
  CustomModalService,
  FileUploadConfig,
  FileUploadResult,
  FileUploadComponent,
} from '@piqet-angular/shared';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-new-add-project-scenario',
  templateUrl: './new-add-project-scenario.component.html',
  styleUrls: ['./new-add-project-scenario.component.scss'],
})
export class NewAddProjectScenarioComponent {
  @ViewChild('fileUpload', { static: false }) fileUploadComponent!: FileUploadComponent;

  selectedFiles: any;
  isShowChange = false;
  imageUrl: any;
  scenarioData: any;
  isImageValid = true;
  @Output() saveScenarioEvent = new EventEmitter<any>();
  submitted: any;
  scenarioAddEditForm!: FormGroup;
  fileBase64: any;
  statusItems: any;
  packageItems: any;
  activatedRouteProjectId: any;
  scenarioId: any;
  isExceeded = false;

  // File upload configuration
  fileUploadConfig: Partial<FileUploadConfig> = {
    placeholderText: 'Scenario image',
    selectButtonText: 'Select file',
    changeButtonText: 'Change',
    removeButtonText: 'Remove',
    showPreview: false,
  };

  constructor(
    private modal: CustomModalService,
    private formBuilder: FormBuilder,
    private router: Router,
    public route: ActivatedRoute,
    private toaster: ToastrService
  ) {
    const url = location.href.split('/');
    this.activatedRouteProjectId = Number(atob(decodeURIComponent(customDecode(url[6]))));

    this.route.queryParams.subscribe((values: any) => {
      let value: any = decrypt(values.param ? values.param : '');
      value = value && !value.includes('undefined') ? JSON.parse(value) : '';
      this.scenarioId = value['id'];
    });
    this.scenarioData = this.modal?.modalService?.config?.initialState?.['scenarioData'];
    this.statusItems = this.scenarioData.statusItems;
    this.packageItems = this.scenarioData.scenariolistIteams;
  }

  ngOnInit() {
    this.scenarioAddEditForm = this.formBuilder.group({
      projectName: [null, [Validators.required, noWhitespaceValidator, Validators.maxLength(50)]],
      projectNameForReport: [
        null,
        [Validators.required, noWhitespaceValidator, Validators.maxLength(15)],
      ],
      share: [null],
      status: [{ value: this.scenarioData.senarioStatusId, disabled: true }],
      description: [null],
    });
  }

  commonInputSearch() {}

  onClose() {
    this.modal.close();
  }

  onBlur(value: any) {
    this.scenarioAddEditForm.controls['projectNameForReport'].setValue(value);
  }

  onFileSelected(result: FileUploadResult) {
    this.selectedFiles = result.fileName;
    this.fileBase64 = result.fileBase64;
    this.imageUrl = result.fileUrl;
    this.isShowChange = !!result.fileName;
    this.isImageValid = result.isValid;
  }

  onSave() {
    this.submitted = true;
    if (this.scenarioAddEditForm.valid && !this.isExceeded) {
      const payload = {
        scenarioName: this.scenarioAddEditForm.controls['projectName'].value,
        name: this.scenarioAddEditForm.controls['projectName'].value,
        shortScenarioName: this.scenarioAddEditForm.controls['projectNameForReport'].value,
        scenarioIdTemp: Number(this.scenarioAddEditForm.controls['share'].value?.idStr),
        senarioStatusId: this.scenarioAddEditForm.controls['status'].value || 0,
        scenarioImage: this.fileBase64 == '' ? null : this.fileBase64,
        ScenarioFile: this.selectedFiles == '' ? null : this.selectedFiles,
        description: this.scenarioAddEditForm.controls['description'].value,
        scenarioTypeId: 1,
        projectId: this.scenarioData.projectId,
        isUseProjectDefault: true,
      };
      this.saveScenarioEvent.emit(payload);
      this.onClose();
    }
  }

  onRemoveConfirmation() {
    // Reset component state
    this.isShowChange = false;
    this.selectedFiles = null;
    this.isImageValid = true;
    this.fileBase64 = null;
    this.imageUrl = null;

    // Reset the file upload component using ViewChild
    if (this.fileUploadComponent) {
      this.fileUploadComponent.reset();
    }

    this.toaster.success('Image has been deleted');
  }

  countCharactersTyped(event: any) {
    const characterCount = event.target.value.length;
    this.isExceeded = characterCount > 600 ? true : false;
  }
}
